import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import instance from "../../Api";
import { useAuth } from "../../AuthContext";
import toast from "react-hot-toast";

function SsoLogin() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) { navigate("/login"); return; }
    verifyToken(token);
  }, []);

  const verifyToken = async (token) => {
    try {
      const res = await instance.post("/verify-sso", { token });
      if (res.data.success) {
        login(res.data.user);
        toast.success("Login successful via SSO");
        navigate("/dashboard");
      } else {
        toast.error(res.data.message);
        navigate("/login");
      }
    } catch {
      toast.error("Invalid or expired SSO link");
      navigate("/login");
    }
  };

  return (
    <div style={{ padding:"50px", textAlign:"center" }}>
      <h2>Logging you in...</h2>
    </div>
  );
}

export default SsoLogin;